import React from 'react';
import { Button, DownloadIcon } from '@razorpay/blade/components';
import { MissingReportExportType } from 'api/types/missingInformationReportTypes';

export const ExportReportButton = ({ type }: { type: MissingReportExportType }) => {
  return (
    <Button
      icon={DownloadIcon}
      iconPosition="left"
      variant="secondary"
      href={`${window.location.origin}/v2/api/csv/organization/missing-information-report?type=${type}`}
      target="_blank">
      Export
    </Button>
  );
};
